// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__18-VE","large":"Button_large__1ArwL","transparent":"Button_transparent__17AEX","light":"Button_light__2rvCn","fullWidth":"Button_fullWidth__3Bhba"};